module.exports = __webpack_public_path__ + "img/140.c406eb1a.jpg";